/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
.container {
  display: flex;
  gap: calc(var(--spacing, 0.25rem) * 4);
  height: calc(var(--spacing, 0.25rem) * 6);
  align-items: center;
  justify-items: center;
}
.progressWrapper {
  box-sizing: border-box;
  --tw-border-style: solid;
  border-style: solid;
  border-color: var(--color-emphasis-low, #d4d4d4);
  background-color: var(--color-white, #fff);
  border-radius: calc(infinity * 1px);
  width: 100%;
  height: calc(var(--spacing, 0.25rem) * 2);
}
.progressBar {
  background-color: var(--color-primary-500);
  height: 100%;
  border-radius: calc(infinity * 1px);
  border-color: var(--color-emphasis-low, #d4d4d4);
}
.percentText {
  color: var(--color-emphasis-medium, #525252);
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
}
